import React, { useState, useEffect } from 'react';
import DataCollection from '../../shared/DataCollection';
import AreaCardList from './AreaCardList.js';
import { useTranslation } from 'react-i18next';

export const ListAreas = (props) => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const collection = 'areas';

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  const columns = [
    {name: t("area"),       selector: row => row.name},
    {name: t("nicknames"),  selector: row => row.matches},
    {name: t("created_by"), selector: row => row.created_by},
  ];

  return (
    <DataCollection
      collection={collection}
      columns={columns}
      mobileComponent={(data, onRefresh) => (
        <AreaCardList data={data} onRefresh={onRefresh} />
      )}
    />
  );
}

export default ListAreas;
